import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface HVACProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const HVAC: React.FC<HVACProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [hvac, set_hvac] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['HVAC']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'HVAC': [b.values?.['Major Systems']?.['HVAC']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'HVAC';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(hvac)}
                />
            ) : (
                <MoneyBox
                    id={'hvac'}
                    allowNegative={false}
                    value={hvac}
                    onChange={(value) => set_hvac(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
